import React from 'react';
import {UserModelManager} from "../user-manager";

export class Confirm extends React.Component {
    constructor(props) {
        super(props);

        this.confirm();

        this.state = {
            success: null
        }
    }

    confirm() {
        UserModelManager.confirmUser(this.props.confirmationToken)
            .finally(() => {
            })
            .then(() => {
                this.setState({success: true});
            }).catch(() => {
                this.setState({success: false});
            }
        );
    }

    render() {
        return (
            <div className="container page confirmation">
                <div className="title">Confirmation</div>
                <p>{this.state.success !== null ? (this.state.success ?
                    'Votre compte est validé, vous pouvez vous connectez avec les identifiants saisis.' :
                    'Une erreur est survenue.') :
                    <div className="loading"><img src="/loading.gif" alt="loading"/></div>}</p>
            </div>
        );
    }
}
